<script setup lang="ts">
import { COMPANY_TELEGRAM_LINK } from '@/shared/constants/contacts';

const { t } = useI18n();
</script>

<template>
  <a
    class="telegram-support-button"
    :href="COMPANY_TELEGRAM_LINK"
    target="_blank"
    :aria-label="t('supportInTelegram')"
  >
    {{ t('supportInTelegram') }}
  </a>
</template>

<style lang="less">
.telegram-support-button {
  display: inline-flex;
  justify-content: center;
  gap: @size-x2;
  align-items: center;
  vertical-align: top;
  font-size: 14px;
  font-weight: 600;
  line-height: 130%;
  width: 100%;
  border-radius: @size-x3;
  transition: all @A linear;
  height: 43px;
  padding: @size-x3 @size-x4;
  white-space: nowrap;
  color: @color-tango;
  background-color: rgba(@color-tango, 0.1);

  &:hover {
    color: #fff;
    background-color: rgba(@color-tango, 0.75);
  }
}
</style>
